import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { Typography } from '@mui/material';


function MobileDrawerContent() {

  return (
    <div>
      <List>
        <ListItem>
            <Typography variant="caption"><a className="simple-link" href='/terms'>Terms & Condition</a></Typography>
          </ListItem>
		  <ListItem>
            <Typography variant="caption"><a className="simple-link" href='/privacy'>Privacy Policy</a></Typography>
          </ListItem>
		  <ListItem>
            <Typography variant="caption"><a className="simple-link" href='/dmca'>DMCA</a></Typography>
          </ListItem>
		  <ListItem>
            <Typography variant="caption"><a className="simple-link" href='/contactform'>Contact Us</a></Typography>
          </ListItem>
       
      </List>
    </div>
  );
}
export default MobileDrawerContent;